<template>
  <v-layout ma-0 pa-0 row wrap>
    <v-flex xs12>
      <v-title>Authorisation</v-title>
    </v-flex>
    <v-flex xs6>
      <v-radio-group
        id="auth"
        v-model="authLevel"
        row
        :disabled="!isAdmin || !authLevel"
        @change="changeAuth"
      >
        <v-radio label="Dealer" value="Dealer"></v-radio>
        <v-radio label="Admin" value="Admin"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex xs6>
      <v-select
        @change="changeAuth"
        :items="items"
        v-model="authGroup"
        label="Authorisation Group"
        :disabled="!isAdmin || !authGroup"
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapDealerActions } = createNamespacedHelpers(
  `orders/dealer`
);
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);

export default {
  name: 'AuthDetails',
  props: ['dealer'],
  data: () => {
    return {
      authLevel: null,
      authGroup: null,
      items: [
        'Dealer',
        'DealerManagers',
        'Helpdesk',
        'Administrators',
        'Customer',
      ],
    };
  },
  computed: {
    ...mapOrderGetters(['isAdmin']),
    currentDealer: {
      get() {
        return this.dealer;
      },
      set(newValue) {
        this.dealer = newValue;
      },
    },
  },
  created() {
    this.getAuth(); 
  },
  watch: {
    dealer(val) {
      this.getAuth();
    },
  },
  methods: {
    ...mapDealerActions(['updateAuth', 'getAuth', 'getDealer']),
    getAuth() {
      let vm = this;
      vm.getDealer(vm.dealer.dealerID)
        .then(data => { 
          if (data) {
            vm.currentDealer.deactivated = data.deactivated;
            vm.authLevel = auth && auth.authLevel;
            vm.authGroup = auth && auth.authGroup;
          }
        })
        .catch(() => {});
    },
    changeAuth() {
      let vm = this;
      vm.dealer.authLevel = vm.authLevel;
      vm.dealer.authGroup = vm.authGroup;
      vm.currentDealer = vm
        .updateAuth(vm.dealer)
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style scoped></style>
